module.exports = __webpack_public_path__ + "img/boxicons.dad92ba1.svg";